import axios from "~/plugins/axios";

export default {
  paginate(
    page = 1,
    perPage = 15,
    includes = [
      "global_automation",
      "extending_searches",
      "departments",
      "users",
      "signals",
      "task_product_labels",
      "email_user",
      "email_account",
      "email_template",
      "html_email_template",
    ],
  ) {
    return axios.get("/web_api/v1/global_automation_configuration", {
      params: {
        page,
        perPage,
        includes,
      },
    })
      .then((response) => response.data);
  },
  paginateActive(
    page = 1,
    perPage = 15,
    includes = [
      "global_automation",
      "extending_searches",
      "departments",
      "users",
      "signals",
      "task_product_labels",
      "email_user",
      "email_account",
      "email_template",
      "html_email_template",
    ],
  ) {
    return axios.get("/web_api/v1/global_automation_configuration/active", {
      params: {
        page,
        perPage,
        includes,
      },
    })
      .then((response) => response.data);
  },
  getById(globalAutomationConfigurationId, includes = [
    "global_automation.global_search",
    "global_automation.global_email_template",
    "global_automation.global_html_email_template",
    "global_automation.automation_action",
    "global_automation.global_extending_searches",
    "global_automation.global_automation_configurations",
    "extending_searches",
    "departments",
    "users",
    "task_product_labels",
    "email_user",
    "email_account",
    "email_template",
    "html_email_template",
  ]) {
    return axios
      .get(`/web_api/v1/global_automation_configuration/${globalAutomationConfigurationId}`, {
        params: {
          includes,
        },
      })
      .then((response) => response.data);
  },
  findOrCreateByGlobalAutomation(globalAutomationId, includes = [
    "global_automation.global_search",
    "global_automation.global_email_template",
    "global_automation.global_html_email_template",
    "global_automation.automation_action",
    "global_automation.global_extending_searches",
    "global_automation.global_automation_configurations",
    "extending_searches",
    "departments",
    "users",
    "task_product_labels",
    "email_user",
    "email_account",
    "email_template",
    "html_email_template",
  ]) {
    return axios
      .get(`/web_api/v1/global_automation_configuration/find_or_create_by_global_automation/${globalAutomationId}`, {
        params: {
          includes,
        },
      })
      .then((response) => response.data);
  },
  create(globalAutomationConfiguration) {
    return axios
      .post("/web_api/v1/global_automation_configuration", globalAutomationConfiguration)
      .then((response) => response.data);
  },
  update(globalAutomationConfiguration, includes = [
    "global_automation.global_search",
    "global_automation.global_email_template",
    "global_automation.global_html_email_template",
    "global_automation.automation_action",
    "global_automation.global_extending_searches",
    "global_automation.global_automation_configurations",
    "extending_searches",
    "departments",
    "users",
    "task_product_labels",
    "email_user",
    "email_account",
    "email_template",
    "html_email_template",
  ]) {
    return axios
      .put(`/web_api/v1/global_automation_configuration/${globalAutomationConfiguration.id}`, globalAutomationConfiguration, {
        params: {
          includes,
        },
      })
      .then((response) => response.data);
  },
  destroy(globalAutomationConfigurationId) {
    return axios
      .delete(`/web_api/v1/global_automation_configuration/${globalAutomationConfigurationId}`)
      .then((response) => response.data);
  },
  run(globalAutomationConfigurationId) {
    return axios
      .post(`/web_api/v1/global_automation_configuration/${globalAutomationConfigurationId}/run`)
      .then((response) => response.data);
  },
  deactivate(globalAutomationConfigurationId) {
    return axios.patch(`/web_api/v1/global_automation_configuration/${globalAutomationConfigurationId}/deactivate`);
  },
  activate(globalAutomationConfigurationId, interval) {
    return axios.patch(`/web_api/v1/global_automation_configuration/${globalAutomationConfigurationId}/activate`, {
      run_interval: interval,
    });
  },
  paginateSearchables(
    globalAutomationConfigurationId,
    page,
    perPage,
    name,
    include = [
      "customer",
    ],
  ) {
    return axios
      .get(`/web_api/v1/global_automation_configuration/${globalAutomationConfigurationId}/searchables`, {
        params: {
          page,
          perPage,
          include,
        },
      })
      .then((response) => response.data);
  },
};
